import React from 'react';
import common from './../../common';

const NextBtn = (props) => {
    const isSecondary = props.isSecondary === true;
    const isNoBorder = props.isNoBorder === true;
    let btnClass = common.makeClasses({
        'si-btn': true,
        'si-btn-secondary': isSecondary,
        'si-btn-primary': !isSecondary && !isNoBorder && !props.isDisabled,
        'si-no-border-btn': isNoBorder,
        'si-btn-disabled': props.isDisabled,
        'si-transfer-btn': props.isTransferBtn,
        'si-subs-btn': props.isSubsBtn,
    });
    const clickHandler = {
        onClick: props.isDisabled ? () => {
        } : () => props.handler()
    };
    const title = props.showTitle ? props.tooltipText : '';
    return <div className={btnClass} {...clickHandler} title={title}>
        {props.showIcon ? <i className={props.iconClass} /> : null}
        <span>{props.text}</span>
    </div>
};
export default NextBtn;


// WEBPACK FOOTER //
// ./src/components/onboarding/NextBtn.js